<div class="row mt-5">
  <div class="col-12 mx-auto">
    <div class="row">
      <div class="col-4 mx-auto">
        <img src="../../assets/images/150ppi/150ppi/Web Portal-วิกฤต-ตัด-01.png" style="width: 100%;">
      </div>
      <div class="col-4 mx-auto">
        <img src="../../assets/images/150ppi/150ppi/Web Portal-วิกฤต-ตัด-02.png" style="width: 100%;">
      </div>
      <div class="col-4 mx-auto">
        <img src="../../assets/images/150ppi/150ppi/Web Portal-วิกฤต-ตัด-03.png" style="width: 100%;">
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/verify2/verify2.component.html